export const SELECTED_SAVED_SEARCH_URL_KEY = 'selectedSearch';
